import React from 'react';
import 'sass/copyright.scss';

const copyRight = () =>  <div className="copyright">© LizardThemes 2011-{new Date().getFullYear()}</div>;

export default copyRight;
